import { register } from "../../helpers/stimulus"

import "@/styles/online_accounts_index.scss"

import DisclosureItemController from "../../controllers/disclosure_item_controller"

const setupStimulus = (): void => {
  register("disclosure-item", DisclosureItemController)
}

setupStimulus()
